module.exports = __webpack_public_path__ + "static/petroshop-complete-3205aedcc15dadadabc741369faff9fc.jpg";